import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import LanguageSelectStore from './store';

const styles = require('./index.less');
/**
 * 语言选择器
 * @param store {LanguageSelectStore}
 * @param className
 * @returns {JSX.Element}
 * @constructor
 */
const LanguageSelect = ({ store, className }) => {
  const renderList = () => {
    return store.languageList.map((item, key) => {
      return (
        <div
          key={key}
          className={cx(styles.listItem, store.currentLanguageObject?.languageKey === item.languageKey && styles.currentLanguageColor)}
          onClick={() => store.onRedirectLanguage(item.languageKey)}
        >
          {item.language}
        </div>
      );
    });
  };
  return (
    <div className={cx(styles.root, className)}>
      <div className={cx(styles.innerPart, styles.expandInnerPart)} onClick={store.onExpandListStatusChange}>
        <div className={styles.icon} />
        <div className={styles.currentLanguage}>{store.currentLanguageObject?.language}</div>
        <div className={cx(styles.arrowIcon, store.isExpand && styles.upArrow)} />
      </div>
      <div className={cx(styles.listPart, store.isExpand && styles.expandListPart)}>
        <div className="xfe-group-3" data-name="modal">
          {renderList()}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(LanguageSelect, LanguageSelectStore);
